/**
 * Эта штука будет делать нам объекты из 2 массивов, пока Даня не сделает объекты на бэке
 * @param keys - массив ключей
 * @param values - массив значений
 */
const createObject = (keys: string[], values: string[]) => {
    let result = {}
    try {
        for (let i = 0; i < keys.length; i++) {
            result[keys[i]] = values[i];
        }
    } catch (e) {
        console.error("Cannot create object")
    }
    return result;
}

export default createObject
